module.exports = __webpack_public_path__ + "static/img/background.2ea537d5.svg";